import { AwsRum, AwsRumConfig } from 'aws-rum-web';

let awsRumInstance: AwsRum | null = null;

export function initializeAwsTracking(config: {
  AWS_RUM_APP_ID?: string;
  AWS_RUM_POOL_ID?: string;
  REGION?: string;
}): AwsRum | null {
  if (awsRumInstance) return awsRumInstance;

  if (!config.AWS_RUM_APP_ID || !config.AWS_RUM_POOL_ID || !config.REGION) {
    console.warn('App Config missing required AWS RUM parameters. Skipping AWS RUM initialization.');
    return null;
  }

  let awsRum: AwsRum | null = null;
  try {
    const rumConfig: AwsRumConfig = {
      batchLimit: 10,
      cookieAttributes: { unique: true },
      dispatchInterval: 5000,
      identityPoolId: config.AWS_RUM_POOL_ID,
      endpoint: `https://dataplane.rum.${config.REGION}.amazonaws.com`,
      telemetries: ['http', 'errors'],
      allowCookies: true,
      enableXRay: true,
      sessionEventLimit: 1000,
      sessionSampleRate: 1.0,
      signing: true,
    };

    const APPLICATION_ID: string = config.AWS_RUM_APP_ID;
    const APPLICATION_VERSION: string = '1.0.0';
    const APPLICATION_REGION: string = config.REGION;

    awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      rumConfig
    );

    console.log('AWS RUM initialized successfully.');
    awsRumInstance = awsRum;

    window.addEventListener('beforeunload', () => {
      awsRum?.dispatch();
    });

    trackAwsRumEvent('proprio.tracking_init', { context: 'AWS Rum tracking initialized.' });
    return awsRum;
  } catch (error) {
    console.error('Error initializing AWS RUM:', error);
  }
  return null;
};

export function getAwsRum(): AwsRum | null {
  return awsRumInstance;
};

export function trackAwsRumError(error: Error): void {
  const rum = getAwsRum();
  if (!rum) {
    console.info('AWS RUM is not initialized. Cannot track error in AWS RUM');
    return;
  }
  try {
    rum.recordError(error);
    rum.dispatch();
  } catch (err) {
    console.error('Error recording AWS RUM error:', err);
  }
};

export function trackAwsRumEvent(eventType: string, eventData: object): void {
  const rum = getAwsRum();
  if (!rum) {
    console.info('AWS RUM is not initialized. Cannot track event in AWS RUM');
    return;
  }
  try {
    rum.recordEvent(eventType, eventData);
  } catch (error) {
    console.error('Error recording AWS RUM event:', error);
  }
};
